import { HTTP_VERBS } from "../../enums";

export const httpVerb = HTTP_VERBS.GET;
export const url = "/api/v1/acp/tasks/:acpId";

export class Params {
	public acpId!: number;
}

export class Response {}
